<div ui-row [uiAlign]="'middle'">
  <div ui-col class="cadence-pager-wrapper" [ngClass]="{ 'sp-pb-32': !canGoToLatest() }">
    <div ui-row [uiAlign]="'middle'" uiJustify="center">
      <div class="go-to-prev sp-pr-20 text-color-gray-6" (click)="goToPrev()" [ngClass]="{ 'sp-pr-32': !canGoToPrev(), 'content-hidden': !canGoToPrev() }">
        <ui-icon uiTheme="outline" uiType="chevron-left-big" class="fs-12px"></ui-icon>
      </div>

      <div ui-row [uiAlign]="'middle'">
        <p class="cadence-start-end text-color-gray-13 fs-14px fw-500">{{ cadenceStartDate | pagerDate }}<span class="sp-pl-4 sp-pr-4">-</span>{{ cadenceEndDate | pagerDate }}</p>
      </div>

      <div class="go-to-next sp-pl-20 text-color-gray-6" (click)="goToNext()" [ngClass]="{ 'sp-pl-32': !canGoToNext(), 'content-hidden': !canGoToNext() }">
        <ui-icon uiTheme="outline" uiType="chevron-right-big" class="fs-12px"></ui-icon>
      </div>
    </div>

    <div *ngIf="canGoToLatest()" ui-row [uiAlign]="'middle'" uiJustify="center" class="sp-pt-12" (click)="goToLatest()">
      <p class="view-recent fw-500 fs-14px">View most recent</p>
    </div>
  </div>
</div>
